<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th>Номер</th>
          <th>Широта</th>
          <th>Долгота</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="point in value" v-bind:key="point.id">
          <td>{{ point.id }}</td>
          <td>{{ point.latitude }}</td>
          <td>{{ point.longitude }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "PointsList",
  props: {
    value: Array
  }
};
</script>